module.exports = __webpack_public_path__ + "h5/img/index-banner2.ba2eb93c.png";